import type { SignOffField } from "../../shared/api-types/training";

import { ROLE_CODES } from "../../constants";

/**
 * The crew role that owns each sign-off, so a Trainer cannot rewrite an Assessor's passed
 * date from the shared users-training list. Superadmin is allowed everywhere and is added
 * by the consumer. There is no permission code covering sign-offs, so this has to be a
 * role check rather than the usual `WithPermission`.
 */
export const SIGN_OFF_FIELD_ROLE: Record<SignOffField, string> = {
  classroom_attendance: ROLE_CODES.TRAINER,
  classroom_test: ROLE_CODES.TRAINER,
  instructor_complete: ROLE_CODES.INSTRUCTOR,
  assessor_passed: ROLE_CODES.ASSESSOR,
  checker_passed: ROLE_CODES.CHECKER,
};

/** Label shown as the dialog title, so the editor can see which sign-off they are correcting. */
export const SIGN_OFF_FIELD_LABEL_KEY: Record<SignOffField, string> = {
  classroom_attendance: "training.classroom_attendance",
  classroom_test: "training.classroom_test",
  instructor_complete: "training_pages.instructor_complete",
  assessor_passed: "training_pages.assessor_passed",
  checker_passed: "training_pages.checker_passed",
};
